import React from "react";
import { Link } from "react-router-dom";
import { CHECK_ICON } from "../../lib/assets";
import { SERVICES } from "../../content/siteContent";

export const SecpHomeSection = () => {
  const secpService =
    SERVICES.find((service) => service.slug === "secp-services") || SERVICES[0];

  return (
    <section className="home-secp-section">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <div className="home-secp-content">
              <div className="section-title mb-30 tg-heading-subheading animation-style2">
                <span className="sub-title tg-element-title">SECP Services</span>
                <h2 className="title tg-element-title">
                  Complete SECP registration support for businesses in Pakistan
                </h2>
              </div>
              <p>{secpService.intro}</p>

              <div className="home-secp-points">
                <ul className="list-wrap">
                  {secpService.overviewItems.slice(0, 3).map(([title, text]) => (
                    <li key={title}>
                      <img src={CHECK_ICON} alt="" />
                      <div>
                        <h5>{title}</h5>
                        <p>{text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="home-secp-actions">
                <Link to={`/services/${secpService.slug}`} className="btn">
                  Explore SECP Service
                </Link>
                <Link to="/contact" className="btn transparent-btn">
                  Book Consultation
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="home-secp-grid">
              <div className="home-secp-feature-card home-secp-feature-card-primary">
                <span className="label">Core Service</span>
                <h3>{secpService.shortTitle}</h3>
                <p>{secpService.cardText}</p>
              </div>

              <div className="home-secp-feature-card">
                <span className="label">Typical Timeline</span>
                <h4>{secpService.processDuration}</h4>
                <p>Structured guidance from consultation to approval.</p>
              </div>

              <div className="home-secp-feature-card">
                <span className="label">What We Handle</span>
                <h4>Name reservation, filing, and compliance</h4>
                <p>
                  Private limited companies, single member companies, LLPs,
                  foreign registrations, and post-registration support.
                </p>
              </div>

              <div className="home-secp-feature-card">
                <span className="label">Why Businesses Choose Zawix</span>
                <ul className="list-wrap">
                  {secpService.highlights.slice(0, 3).map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
